<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <b-card>
          <div slot="header">
            <strong>{{ card.title }}</strong>
          </div>
          <div class="row">
            <div class="col-sm-4">
              <b-form-fieldset label="Nom">
                <b-form-input type="text" id="surname" v-model.trim="data.surname" autofocus></b-form-input>
              </b-form-fieldset>
            </div><!--/.col-->
            <div class="col-sm-4">
              <b-form-fieldset label="Prénom">
                <b-form-input type="text" id="name" v-model.trim="data.name"></b-form-input>
              </b-form-fieldset>
            </div><!--/.col-->
            <div class="col-sm-2">
              <b-form-fieldset label="Fixe">
                <b-form-input type="text" id="tel_fixe" v-model.trim="data.landline"></b-form-input>
              </b-form-fieldset>
            </div><!--/.col-->
            <div class="col-sm-2">
              <b-form-fieldset label="Mobile">
                <b-form-input type="text" id="tel_mobile" v-model.trim="data.gsm"></b-form-input>
              </b-form-fieldset>
            </div><!--/.col-->
          </div><!--/.row-->
          <div class="row">
            <div class="col-sm-7">
              <b-form-fieldset label="Adresse">
                <b-form-input type="text" id="address" v-model.trim="data.street"></b-form-input>
              </b-form-fieldset>
            </div><!--/.col-->
            <div class="col-sm-2">
              <b-form-fieldset label="CP">
                <b-form-input type="number" id="postal" v-model.trim="data.cp" placeholder="63000">{{ data.cp }}</b-form-input>
              </b-form-fieldset>
            </div><!--/.col-->
            <div class="col-sm-3">
              <b-form-fieldset label="Ville">
                <b-form-input type="text" id="town" v-model.trim="data.town"></b-form-input>
              </b-form-fieldset>
            </div><!--/.col-->
          </div><!--/.row-->
          <div class="row">
            <div class="col-sm-5">
              <b-form-fieldset label="e-mail">
                <b-form-input type="email" id="email" v-model.trim="data.email"></b-form-input>
              </b-form-fieldset>
            </div>
            <div class="col-sm-7">
              <b-form-fieldset label="Commentaire">
                <b-form-input type="text" id="comment" v-model.trim="data.comment"></b-form-input>
              </b-form-fieldset>
            </div>
          </div>
          <div slot="footer">
            <b-button type="submit" size="sm" variant="success" v-on:click="create" :disabled="! createBtnEnabled"><i class="fa fa-dot-circle-o"></i> Créer un client</b-button>
            <b-button type="submit" size="sm" variant="success" v-on:click="create" :disabled="! saveBtnEnabled"><i class="fa fa-edit-o"></i> Sauvegarder les modifications</b-button>
            <b-button type="reset" size="sm" variant="danger" v-on:click="reset"><i class="fa fa-ban"></i> Réinitialiser</b-button>
          </div>
        </b-card>
      </div>
    </div><!--/.row-->
    <div class="row">
      <div class="col-md-12">
        <b-card>
          <div class="row">
            <span>Numéro de commande&nbsp;</span>
            <input type="text" id="cmdid" v-model.trim="orderID" v-on:keyup.enter="openOrder"></input><span>&nbsp;</span>
            <b-button type="submit" size="sm" variant="success" v-on:click="openOrder"><i class="fa fa-search"></i> Accéder à une commande</b-button>
          </div>
        </b-card>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <b-card header="Résultats de la recherche">
          <table class="table table-bordered table-striped table-sm">
            <thead>
              <tr>
                <th></th>
                <th>e-mail</th>
                <th>Prénom</th>
                <th>Nom</th>
                <th>Tel fixe/mobile</th>
                <th>Adresse</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr is="customer-row" v-for="customer in customers" v-bind:key="customer.id" v-bind:customer="customer" v-on:order="listOrders" v-on:edit="edit">
              </tr>
            </tbody>
          </table>
        </b-card>
      </div><!--/.col-->
    </div><!--/.row-->
    <!-- modal to display error -->
    <b-modal size="lg" ok-only v-model="showModalError">
      <span v-html="lastError"></span>
    </b-modal>
    <b-modal size="lg" ok-only v-model="showCustomerOrders" ok-title="Fermer">
      <div slot="modal-title">
        <strong>Commandes en cours du client {{ activeCustomerName }} - {{ displayedCustomerName }}</strong>
      </div>
      <b-card header="Commandes en cours">
        <table class="table table-bordered table-striped table-sm">
          <thead>
            <tr>
              <th>Numéro de commande</th>
              <th>Date de mise à disposition</th>
              <th>Nombre de produits</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr is="order-row" v-for="order in customerOrderList" v-bind:key="order.id" v-bind:order="order" v-on:select="doOrder" v-on:print="doPrint">
            </tr>
          </tbody>
        </table>
      </b-card>
      <b-button type="submit" size="sm" variant="success" v-on:click="doOrder(0)"><i class="fa fa-dot-circle-o"></i> Créer une nouvelle commande client</b-button>
    </b-modal>
  </div><!-- whole page -->
</template>

<script>
import store from '@/store'
import router from '@/router'
import _ from 'lodash'
// import Autocomplete from 'vue2-autocomplete-js'

var customerResult = {
  template: '<tr><td style="cursor: pointer" v-on:click="$emit(\'edit\', customer.id )"><i class="fa fa-edit"/></td><td>{{ customer.email }}</td><td>{{ customer.name }}</td><td>{{ customer.surname }}</td><td>{{ customer.landline }} / {{ customer.gsm }}</td><td>{{ customer.street }} {{ customer.cp }} {{ customer.town }}</td><td style="cursor: pointer" v-on:click="$emit(\'order\', customer.id )"><i class="fa fa-shopping-cart"/></td></tr>',
  props: ['customer']
}

var orderPerCustomerResult = {
  template: '<tr><td>{{ order.id }}</td><td>{{ order.delivery }}</td><td>{{ order.goods_nb }}</td><td style="cursor: pointer" v-on:click="$emit(\'select\', order.id )"><i class="fa fa-shopping-cart"/></td><td style="cursor: pointer" v-on:click="$emit(\'print\', order.id )"><i class="fa fa-print"/></td></tr>',
  props: ['order']
}

export default {
  name: 'client',
  components: {
    'customer-row': customerResult,
    'order-row': orderPerCustomerResult
  },
  data: function () {
    return {
      lastClientNb: 40,
      data: {
        id: 0,
        name: '',
        surname: '',
        email: '',
        gsm: '',
        landline: '',
        street: '',
        cp: undefined,
        town: '',
        comment: ''
      },
      orderID: '',
      isSearched: false,
      createBtnEnabled: true,
      saveBtnEnabled: false,
      showModalError: false,
      showCustomerOrders: false,
      customerOrderList: [],
      lastError: '',
      loadingSpinner: true,
      activeCustomerName: '',
      displayedCustomerName: '',
      customers: [],
      card: {
        title: 'Recherche/Création Client'
      }
    }
  },
  beforeCreate () {
    if (!store.state.isLogged) {
      router.push('/')
    }
  },
  created () {
    // récupérer les données lorsque la vue est créée et
    // que les données sont déjà observées
    this.fetchLastCustomers()
  },
  watch: {
    data: {
      handler: function () {
        this.change()
      },
      deep: true
    }
  },
  methods: {
    fetchLastCustomers () {
      this.createBtnEnabled = false
      this.$Progress.start()
      this.$http.get(process.env.API_URL + '/customer/lasts', {params: {last: this.lastClientNb}}).then((response) => {
        this.customers = []
        this.customers = response.body.Customers
        this.$Progress.finish()
        this.createBtnEnabled = true
        this.saveBtnEnabled = false
        this.card.title = 'Recherche/Création Client'
      },
      (error) => {
        if (error.status === 403) {
          this.$eventHub.$emit('redirectToLogin')
        } else {
          // allow resubmit of data
          this.createBtnEnabled = true
          this.saveBtnEnabled = false
          this.$Progress.fail()
          this.customers = []
          this.lastError = error.body
          if (error.status !== 404) {
            this.showModalError = true
          }
        }
      })
    },
    create () {
      this.createBtnEnabled = false
      this.$Progress.start()
      this.$http.post(process.env.API_URL + '/customer/create', this.data).then((response) => {
        this.customers = []
        this.customers.push(response.body)
        this.$Progress.finish()
        this.createBtnEnabled = true
        this.saveBtnEnabled = false
        this.card.title = 'Recherche/Création Client'
      },
      (error) => {
        // allow resubmit of data
        this.createBtnEnabled = true
        this.saveBtnEnabled = false
        this.$Progress.fail()
        this.customers = []
        this.lastError = error.body
        this.showModalError = true
      })
    },
    reset () {
      console.log('reset')
      Object.assign(this.$data, this.$options.data.call(this))
      this.createBtnEnabled = true
      this.saveBtnEnabled = false
    },
    change: _.debounce(function () {
      this.$Progress.start()
      var req = Object.assign({}, this.data)
      req.limit = this.lastClientNb
      this.isSearched = true
      this.$http.get(process.env.API_URL + '/customer/search', {params: req}).then((response) => {
        this.customers = response.body.Customers
        this.$Progress.finish()
      },
      (error) => {
        this.$Progress.fail()
        this.customers = []
        if (error.status === 403) {
          this.$eventHub.$emit('redirectToLogin')
        }
      })
    }, 500),
    doOrder (orderId) {
      var id = this.activeCustomerName
      console.log('do order for id ' + id + ' / ' + orderId)
      router.push({name: 'Commande client', params: { id: id, orderid: orderId }})
    },
    doPrint (orderId) {
      this.$Progress.start()
      var id = this.activeCustomerName
      console.log('do print for id ' + id + ' / ' + orderId)
      var req = {id: orderId}
      this.$http.get(process.env.API_URL + '/order/print', {params: req, responseType: 'arraybuffer'}).then((response) => {
        var base64EncodedPDF = response.body
        this.src = base64EncodedPDF
        this.$Progress.finish()
        this.printOrder()
      })
    },
    listOrders (id) {
      console.log('do list order for id ' + id)
      // router.push({name: 'Commande client', params: { id: id }})
      this.showCustomerOrders = true
      this.customerOrderList = ''
      this.$Progress.start()
      this.createBtnEnabled = false
      this.saveBtnEnabled = false
      this.loadingSpinner = true
      this.activeCustomerName = id
      this.displayedCustomerName = ''
      for (var i = 0; i < this.customers.length; i++) {
        if (this.customers[i].id === id) {
          this.displayedCustomerName = this.customers[i].name
          break
        }
      }
      this.$http.get(process.env.API_URL + '/customer/get-orders', {params: {'id': id}}).then((response) => {
        // response.body
        this.loadingSpinner = false
        this.$Progress.finish()
        this.createBtnEnabled = false
        this.saveBtnEnabled = true
        // fill customerOrderList
        this.customerOrderList = []
        for (var i = 0; i < response.body.orders.length; i++) {
          // var total_price_ht = 0
          var order = {id: response.body.orders[i].order_id}
          // nombre de produits
          order.goods_nb = response.body.orders[i].goods_nb
          // nombre de ref de produit
          order.goods_ref_nb = response.body.orders[i].goods_ref_nb
          // date de livraison
          order.delivery = response.body.orders[i].delivery
          this.customerOrderList.push(order)
        }
      },
      (error) => {
        this.createBtnEnabled = true
        this.saveBtnEnabled = false
        this.$Progress.fail()
        if (error.status === 403) {
          this.$eventHub.$emit('redirectToLogin')
        }
      })
    },
    // function call on "modify" button
    edit (id) {
      console.log('do edit customer for id ' + id)
      // function call on "modify" button
      router.push({name: 'Edition de client', params: { id: id }})
    },
    // function for direct order access
    openOrder () {
      if (this.orderID >= 1) {
        console.log('open Order ' + this.orderID)
        this.$http.get(process.env.API_URL + '/order/get-customerid', {params: {'id': this.orderID}}).then((response) => {
          var customerID = response.body.id
          router.push({name: 'Commande client', params: { id: customerID, orderid: this.orderID }})
        },
        (error) => {
          this.$Progress.fail()
          if (error.status === 403) {
            this.$eventHub.$emit('redirectToLogin')
          }
        })
      }
    },
    printOrder () {
      console.log('print clients')
      var base64EncodedPDF = this.src
      var downloadLink = document.createElement('a')
      // downloadLink.target = '_blank'
      downloadLink.download = 'commande.pdf'
      // convert downloaded data to a Blob
      var blob = new Blob([base64EncodedPDF], {type: 'application/pdf'})
      // create an object URL from the Blob
      var URL = window.URL || window.webkitURL
      var downloadUrl = URL.createObjectURL(blob)
      // set object URL as the anchor's href
      downloadLink.href = downloadUrl
      // append the anchor to document body
      document.body.append(downloadLink)
      // fire a click event on the anchor
      downloadLink.click()
      // cleanup: remove element and revoke object URL
      document.body.removeChild(downloadLink)
      URL.revokeObjectURL(downloadUrl)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Client.vue?9cbc7b4c